<template>
    <div
        class="app_checkbox"
        :class="{ app_checkbox_inline: inline, 'w-full': isFull }"
    >
        <!-- [info]: not sure if we need it or not. commenting it for now -->
        <!-- @click="$emit('update:modelValue', $event.target.checked)" -->
        <input
            class="app_checkbox_input"
            :checked="checked"
            :name="name"
            type="checkbox"
            :id="id"
            :value="modelValue"
            @change="$emit('update:modelValue', $event.target.checked)"
            :disabled="isDisabled"
        />
        <!-- {{ modelValue }} -->
        <label
            class="app_checkbox_label"
            :class="{ 'w-full': isFull }"
            :for="id"
        >
            <span
                class="app_checkbox_icon"
                :class="[
                    large ? 'large' : '',
                    bgWhite ? 'bg_white' : '',
                    isSingle ? 'check_icon_single' : '',
                    rounded ? '!rounded-full' : '',
                ]"
            >
                <!-- {{ checked }} -->
                <template v-if="isSingle && checked">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="4"
                        viewBox="0 0 16 4"
                    >
                        <rect
                            id="Rectangle_4379"
                            data-name="Rectangle 4379"
                            width="16"
                            height="4"
                            rx="1"
                            fill="#3de6b7"
                        />
                    </svg>
                </template>
                <template v-else-if="checked">
                    <fa
                        :icon="['fas', 'check']"
                        class="text-sm leading-[0.875rem] text-dark-100"
                    >
                    </fa>
                </template>
            </span>
            <template v-if="text">
                {{ text }}
            </template>
            <slot name="checkboxLabel"></slot>
        </label>
    </div>
</template>

<script>
export default {
    name: 'AppCheckbox',
    props: {
        bgWhite: {
            type: Boolean,
            default: false,
        },
        inline: {
            type: Boolean,
            default: false,
        },
        id: {
            type: [String, Number],
            default: '',
        },
        rounded: {
            type: Boolean,
            default: false,
        },
        text: {
            type: String,
            default: '',
        },
        name: {
            type: String,
            default: '',
        },
        checked: {
            type: Boolean,
            default: false,
        },
        modelValue: {
            type: [String, Number],
            default: '',
        },
        large: {
            type: Boolean,
            default: false,
        },
        isSingle: {
            type: Boolean,
            default: false,
        },
        isFull: {
            type: Boolean,
            default: false,
        },
        isDisabled: {
            type: Boolean,
            default: false,
        },
    },
    setup() {
        const isChecked = () => {
            console.log('check');
        };
        return {
            isChecked,
        };
    },
};
</script>

<style scoped>
.app_checkbox {
    @apply flex items-center;
}

.app_checkbox.app_checkbox_inline {
    @apply inline-block ltr:mr-2 rtl:ml-2;
}

.app_checkbox > .app_checkbox_input[type='checkbox'] {
    @apply opacity-0 hidden;
}

.app_checkbox_icon {
    @apply w-6 h-6 rounded bg-gray-100 dark:bg-black-900 border dark:border-0 border-gray-100 inline-flex mr-2 flex-shrink-0 items-center justify-center relative;
}

.app_checkbox_icon.success {
    @apply border-green-500;
}

.app_checkbox_icon.danger {
    @apply border-red-500;
}

.app_checkbox_icon.large {
    @apply w-8 h-8;
}

.app_checkbox_icon svg {
    @apply hidden w-4 h-3 absolute top-2/4 left-2/4 -translate-x-2/4 -translate-y-2/4;
}

.app_checkbox_label {
    @apply flex items-center cursor-pointer text-sm text-gray-500 dark:text-dm-white;
}

.app_checkbox
    > .app_checkbox_input[type='checkbox']:checked
    + .app_checkbox_label
    > .app_checkbox_icon
    > svg {
    @apply inline-block text-black-900;
}

.app_checkbox
    > .app_checkbox_input[type='checkbox']:checked
    + .app_checkbox_label
    > .app_checkbox_icon {
    @apply bg-gray-100 border-gray-100;
}

.app_checkbox
    > .app_checkbox_input[type='checkbox']:checked
    + .app_checkbox_label
    > .app_checkbox_icon.check_icon_single {
    @apply border border-gray-100 bg-gray-100;
}

.app_checkbox
    > .app_checkbox_input[type='checkbox']:checked
    + .app_checkbox_label
    > .app_checkbox_icon.check_icon_single
    > svg {
    @apply text-green-500 text-xl;
}

.bg_white {
    @apply bg-white dark:bg-black-900;
}
</style>
